export default {
  validate: (value, { typecheck }) => {
    const typechecks = Array.isArray(typecheck) ? typecheck : [typecheck];
    return typechecks.includes(typeof value);
  },
  params: ['typecheck'],
};
